import * as VueI18nVue2And3 from "vue-i18n";
import * as Vue from "vue";
import { computed } from "vue";
import { isVue2 } from "vue-demi";
import messages, { datetimeFormats, numberFormats } from "../locales.js";
if (typeof window === "undefined") {
  global.window = {
    $excalibur: {}
  };
}
window.$excalibur = window.$excalibur || {};
const defaultLocale = "pt-BR";
function getI18nConfig() {
  return {
    locale: defaultLocale,
    fallbackLocale: {
      enUs: ["en-US"],
      en: ["en-US"],
      esMx: ["es-MX"],
      default: [defaultLocale]
    },
    messages,
    numberFormats
  };
}
function setGlobalWindowLocale(localeConfig) {
  var _a;
  if (!((_a = window.$excalibur) == null ? void 0 : _a.locale)) {
    window.$excalibur.locale = localeConfig;
  }
}
function createInstanceVue2() {
  const VueI18n = VueI18nVue2And3 == null ? void 0 : VueI18nVue2And3.default;
  Vue.default.use(VueI18n);
  const i18n = new VueI18n({
    ...getI18nConfig(),
    dateTimeFormats: datetimeFormats,
    silentFallbackWarn: true
  });
  function setLocale(newLocale) {
    i18n.locale = newLocale;
  }
  setGlobalWindowLocale({
    useI18n: {
      t: (key, ...params) => i18n.t(key, ...params),
      tc: (key, ...params) => i18n.tc(key, ...params),
      d: (key, ...params) => i18n.d(key, ...params),
      n: (key, ...params) => i18n.n(key, ...params),
      setLocale
    },
    i18n
  });
}
function createInstanceVue3() {
  const { createI18n } = VueI18nVue2And3;
  const i18n = createI18n({
    ...getI18nConfig(),
    legacy: false,
    globalInjection: true,
    fallbackWarn: false,
    missingWarn: false,
    datetimeFormats
  });
  function setLocale(newLocale) {
    i18n.global.locale.value = newLocale;
  }
  const { t } = i18n.global;
  setGlobalWindowLocale({
    useI18n: {
      ...i18n.global,
      tc: t,
      setLocale
    },
    i18n
  });
}
const activeLocale = computed(() => {
  var _a, _b, _c, _d, _e;
  if (isVue2) {
    return (_b = (_a = window.$excalibur) == null ? void 0 : _a.locale) == null ? void 0 : _b.i18n.locale;
  }
  return (_e = (_d = (_c = window.$excalibur) == null ? void 0 : _c.locale) == null ? void 0 : _d.i18n) == null ? void 0 : _e.global.locale.value;
});
function getLocaleInstance() {
  var _a;
  return (_a = window.$excalibur) == null ? void 0 : _a.locale;
}
function useI18n() {
  var _a;
  if (!((_a = window.$excalibur) == null ? void 0 : _a.locale)) {
    if (isVue2) {
      createInstanceVue2();
    } else {
      createInstanceVue3();
    }
  }
  const { useI18n: useI18nDs } = window.$excalibur.locale;
  return useI18nDs;
}
export {
  activeLocale as a,
  getLocaleInstance as g,
  useI18n as u
};
